import React from 'react';
import logo from './logo.svg';
import ResultsPageView from './results-page/results-page.view';

function App() {
  return (
    <div id="root">
      <ResultsPageView/>
    </div>
  );
}

export default App;
